import { Badge } from "react-bootstrap"
import getPosition from "../utils/getPosition"

const PositionBadges = (({ positions }) => {
  const badges = positions
    .filter((position) => position !== "member")
    .map((position) => (
      <Badge key={position} bg="info" className="fw-semibold fs-8" style={{ width: "7.1rem" }}>
        {getPosition(position)}
      </Badge>
    ))

  if (!badges.length) {
    return <Badge bg="secondary" className="fw-semibold fs-8" style={{ width: "7.1rem" }}>Member</Badge>
  }

  return <>{badges}</>
})
export default PositionBadges